import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://mj-partneri.lovable.app";

const CanonicalUrl = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${pathname === "/" ? "" : pathname}`;
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);
  }, [pathname]);

  return null;
};

export default CanonicalUrl;
